import { useRouter } from 'next/router';
import { PageSortBy } from 'components/page';

interface Props {
  sortBy: string;
  options: {
    text: string;
    value: string;
  }[];
}

const PathsSortBy = ({ sortBy, options }: Props) => {
  const router = useRouter();

  const handleChange = async (value: string) => {
    router.replace({
      query: { ...router.query, sortBy: value }
    });
  };

  return (
    <PageSortBy
      defaultValue={sortBy}
      onChange={handleChange}
      options={options}
      titleMaxWidth={120}
      value={sortBy}
    />
  );
};

export default PathsSortBy;
